import { Stack, Typography } from "@mui/material";
import { workflowTypeCaptionMap } from "@entrilia/shared/utilities/enumCaptions";
import type { WorkflowDetails } from "../../../../../api/types/workflowTypes";
import WorkflowStatusTag from "../../../change-requests/WorkflowStatusTag";

interface Props {
  workflowDetails: WorkflowDetails;
}

const WorkflowRunDetailsPageTitle = ({ workflowDetails }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="h6" noWrap>
          {workflowTypeCaptionMap[workflowDetails.workflow.type] ?? workflowDetails.workflow.type}
        </Typography>
        <WorkflowStatusTag
          workflowStatus={workflowDetails.workflow.status}
          requiresUserAction={workflowDetails.workflow.requiresUserAction}
        />
      </Stack>
      <Typography variant="caption" color="textSecondary">
        Workflow Run
      </Typography>
    </Stack>
  );
};

export default WorkflowRunDetailsPageTitle;
